module.exports = __webpack_public_path__ + "img/页面图_02.e510f978.png";